<template>
  <form
    autocomplete="off"
    @submit.prevent="$emit('submit')"
  >
    <label v-if="displaySrc">Upload image</label>

    <img
      v-if="displaySrc"
      :src="displaySrc"
      class="max-h-[180px] w-fit mb-2 border border-editor-chrome-light"
      alt="Signature Preview"
    >

    <div
      v-if="displaySrc"
      class="flex items-center gap-10"
    >
      <FileUploadButton
        accept=".png, .jpg, .jpeg, .webp"
        text="Change"
        class="text-editor-btn-text !text-base !font-semibold !py-1 !px-0 !min-w-0 hover:underline"
        @file-selected="handleFileSelect"
      />

      <button
        type="button"
        class="text-editor-btn-text !text-base !font-semibold !py-1 !px-0 !min-w-0 hover:underline"
        @click="clearImage"
      >
        Remove
      </button>
    </div>

    <FileUploadButton
      v-else
      :icon="faUpload"
      accept=".png, .jpg, .jpeg, .webp"
      label="Upload image"
      text="Upload Signature"
      class="btn-solid btn-secondary [&_span]:pl-0.5"
      @file-selected="handleFileSelect"
    />
  </form>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { FileUploadButton } from '@/components/buttons';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';

defineEmits(['submit']);

const selectedFile = defineModel('selectedFile');
const formData = defineModel('formData');

const props = defineProps({
  currentSignature: {
    type: [String, File, Blob, Object],
    default: null,
  },
});

// track if we deleted it locally
const isRemoved = ref(false);

const displaySrc = computed(() => {
  // if we clicked remove, dont show anything
  if (isRemoved.value) return null;

  // show the new file if we picked one
  if (selectedFile.value) {
    if (selectedFile.value instanceof File || selectedFile.value instanceof Blob) {
      return URL.createObjectURL(selectedFile.value);
    }
    return selectedFile.value;
  }

  // fallback to the existing one from the store
  if (props.currentSignature) {
    if (props.currentSignature instanceof File || props.currentSignature instanceof Blob) {
      return URL.createObjectURL(props.currentSignature);
    }
    return props.currentSignature;
  }

  return null;
});

const handleFileSelect = (file) => {
  selectedFile.value = file;
  // reset delete flag if we upload something new
  isRemoved.value = false;
};

const clearImage = () => {
  selectedFile.value = null;
  // hide it visually immediately
  isRemoved.value = true;
  formData.value.removePhoto = true;
};

// if parent forces a change, reset our local state
watch(selectedFile, (newVal) => {
  if (newVal) isRemoved.value = false;
});
</script>
